import PropTypes from 'prop-types';
var mediaFunc = {
  xs: PropTypes.func,
  sm: PropTypes.func,
  md: PropTypes.func,
  lg: PropTypes.func
};
var themeProps = PropTypes.shape({
  layout: PropTypes.shape({
    media: {
      xs: PropTypes.string,
      sm: PropTypes.string,
      md: PropTypes.string,
      lg: PropTypes.string
    },
    grid: {
      columns: PropTypes.number,
      gutter: PropTypes.number
    },
    maxSiteWidth: PropTypes.string,
    header: {
      mainHeight: PropTypes.string,
      mobileMainHeight: PropTypes.string,
      accountHeight: PropTypes.string
    },
    page: {
      backgroundColor: PropTypes.string
    }
  })
});
export default {
  themeProps: themeProps,
  mediaFunc: mediaFunc
};